import { render, staticRenderFns } from "./LoadingButtons.vue?vue&type=template&id=0ccdf6ce&scoped=true&"
import script from "./LoadingButtons.vue?vue&type=script&lang=js&"
export * from "./LoadingButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ccdf6ce",
  null
  
)

export default component.exports